

const Spinner = (props) => {
       return(
        <div className='text-center' style={{fontSize: props.fontSize, width: '100%', margin: 'auto', textAlign: 'center' }}>
        <i className="fa fa-spinner fa-spin"/> Please wait ...!</div>   
       );
   }
   export default Spinner;